import { combineReducers } from 'redux';

import AnnouncementReducer from './AnnouncementReducer';
import userProfileReducer from './UserProfileReducer';

export default combineReducers({
    profile: userProfileReducer,
    announcements: AnnouncementReducer,
});
